// client/src/components/agendamentos/TipoAgendamentoSelector.js
import React, { useState } from 'react';
import { ClipboardCheck, Building2, Truck, Briefcase, XCircle } from 'lucide-react';
import PropTypes from 'prop-types';

const TipoAgendamentoSelector = ({ onSelect, onClose }) => {
    const [selectedType, setSelectedType] = useState(null);

    const tipos = [
        {
            id: 'servico',
            titulo: 'Agendamento de Serviço',
            descricao: 'Agende um serviço com um profissional',
            icon: ClipboardCheck,
            cor: 'bg-blue-50 border-blue-200 hover:bg-blue-100',
            iconCor: 'text-blue-600'
        },
        {
            id: 'recurso',
            titulo: 'Locação de Recurso',
            descricao: 'Reserve um espaço, equipamento ou recurso',
            icon: Building2,
            cor: 'bg-green-50 border-green-200 hover:bg-green-100',
            iconCor: 'text-green-600'
        }
    ];

    const handleSelect = (tipo) => {
        setSelectedType(tipo.id);
        setTimeout(() => {
            onSelect(tipo.id);
        }, 300);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full overflow-hidden">
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">
                        O que você deseja agendar?
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <XCircle size={24} />
                    </button>
                </div>

                <div className="p-6">
                    <div className="grid md:grid-cols-2 gap-4">
                        {tipos.map((tipo) => {
                            const Icon = tipo.icon;
                            const isLoading = selectedType === tipo.id;
                            return (
                                <button
                                    key={tipo.id}
                                    onClick={() => handleSelect(tipo)}
                                    disabled={isLoading}
                                    className={`p-6 rounded-xl border-2 text-left transition-all ${tipo.cor} ${
                                        isLoading ? 'opacity-50 cursor-wait' : 'hover:shadow-lg transform hover:-translate-y-1'
                                    }`}
                                >
                                    <div className="flex items-start gap-4">
                                        <div className={`p-3 rounded-lg bg-white ${tipo.iconCor}`}>
                                            <Icon size={28} />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="font-semibold text-gray-800 mb-1">
                                                {tipo.titulo}
                                            </h3>
                                            <p className="text-sm text-gray-500">
                                                {tipo.descricao}
                                            </p>
                                            {isLoading && (
                                                <div className="mt-2 flex items-center gap-2">
                                                    <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                                                    <span className="text-xs text-gray-500">Carregando...</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="bg-gray-50 p-4 border-t">
                    <p className="text-xs text-gray-500 text-center">
                        Escolha o tipo de agendamento para continuar
                    </p>
                </div>
            </div>
        </div>
    );
};

TipoAgendamentoSelector.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default TipoAgendamentoSelector;